// src/components/quickcreate/QuickCreateButton.jsx
// Reusable + button that sits next to any dropdown
// Props:
//   onClick   — opens the modal
//   label     — tooltip text (optional)
//   disabled  — disables button

export default function QuickCreateButton({ onClick, label = "Create new", disabled = false }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={label}
      className={`
        flex-shrink-0 w-8 h-8 rounded-lg
        flex items-center justify-center
        border border-dashed transition-all duration-150
        ${disabled
          ? "border-slate-200 text-slate-300 cursor-not-allowed bg-white"
          : "border-indigo-300 text-indigo-500 bg-indigo-50 hover:bg-indigo-100 hover:border-indigo-400 hover:text-indigo-700 cursor-pointer"
        }
      `}
    >
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M7 1v12M1 7h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    </button>
  );
}
